import { LocalizedError } from '@/core/i18n';
import { fetchJson, HttpError } from '@/core/network';
import {
  AUTH_FAILURE,
  latestUrl,
  parseLatest,
  SynopticApiError,
  type LatestQuery,
  type LatestResponse,
} from './model/synoptic';
import type { Station } from './model/types';

const TOKEN = import.meta.env.VITE_SYNOPTIC_TOKEN?.trim() ?? '';

/** A token is configured; without one the layer explains why it stays empty. */
export const HAS_TOKEN = TOKEN !== '';

export async function fetchStations(
  query: Omit<LatestQuery, 'token'>,
  signal: AbortSignal,
): Promise<Station[]> {
  if (!HAS_TOKEN) throw new LocalizedError('stations:errors.noToken');
  try {
    return parseLatest(await fetchJson<LatestResponse>(latestUrl({ ...query, token: TOKEN }), signal));
  } catch (err) {
    const auth =
      (err instanceof SynopticApiError && err.code === AUTH_FAILURE) ||
      (err instanceof HttpError && (err.status === 401 || err.status === 403));
    if (auth) throw new LocalizedError('stations:errors.token', {}, { cause: err });
    if (err instanceof SynopticApiError || err instanceof HttpError)
      throw new LocalizedError('stations:errors.service', {}, { cause: err });
    throw err;
  }
}
